import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from './api';
import type { AdminMe, CreatorMe } from './types';

export function useAdminMe() {
  return useQuery<AdminMe, ApiError>({
    queryKey: ['admin', 'me'],
    queryFn: () => api.get<AdminMe>('/api/admin/me'),
    retry: (n, err) => !(err instanceof ApiError && err.status === 401) && n < 1,
    staleTime: 60_000,
  });
}

export function useCreatorMe() {
  return useQuery<CreatorMe, ApiError>({
    queryKey: ['creator', 'me'],
    queryFn: () => api.get<CreatorMe>('/api/creator/me'),
    retry: (n, err) => !(err instanceof ApiError && err.status === 401) && n < 1,
    staleTime: 30_000,
  });
}
